var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import "../Button/Button.js";
import ModalDialogCss from "./ModalDialogCss.js";
class ModalDialog extends s {
  constructor() {
    super();
    __publicField(this, "_scrollListener", () => {
      send(ModalDialog.EVENT_KEYS.SCROLL, {}, this);
    });
    __publicField(this, "_keyDownListener", (event) => {
      if (this.hidden === false && event.code === "Escape") {
        this._submit(false);
      }
    });
    __publicField(this, "_hasButtons", () => !isEmpty(this.cancelButton) || !isEmpty(this.confirmButton));
    __publicField(this, "_renderHeader", () => {
      const closeButton = this._hasButtons() ? y`` : y`<i class="close icon" @click="${() => this._submit(false)}"></i>`;
      const headerText = isEmpty(this.header) ? y`` : y`<h2 class="dialog-header">${this.header}</h2>`;
      return y`${closeButton}${headerText}`;
    });
    __publicField(this, "_renderDescription", () => isEmpty(this.description) ? y`` : y`<p>${this.description}</p>`);
    __publicField(this, "_renderButtons", () => {
      if (!this._hasButtons()) {
        return y``;
      }
      const cancelButton = isEmpty(this.cancelButton) ? y`` : y`
            <isceco-button text="${this.cancelButton}" variant="tertiary" @click="${(_) => this._submit(false)}">
            </isceco-button>
        `;
      const confirmButton = isEmpty(this.confirmButton) ? y`` : y`
            <isceco-button text="${this.confirmButton}" variant="primary" @click="${(_) => this._submit(true)}">
            </isceco-button>
        `;
      return y`<div class="dialog-buttons">${cancelButton}${confirmButton}</div>`;
    });
    this.size = "small";
  }
  static get styles() {
    return [ModalDialogCss];
  }
  static get EVENT_KEYS() {
    return {
      SCROLL: "isceco-scroll"
    };
  }
  static get properties() {
    return {
      size: { type: String },
      header: { type: String },
      description: { type: String },
      confirmButton: { type: String, attribute: "confirm-button" },
      cancelButton: { type: String, attribute: "cancel-button" }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("keydown", this._keyDownListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("keydown", this._keyDownListener);
  }
  render() {
    return y`
      <style>@import '${iscecoWidgetLibrary.iconCss}';</style>
      <div class="gray-overlay" @click="${() => this._submit(false)}"></div>
      <div class="dialog-container">
        <div class="dialog ${this.size}" @scroll="${(_) => this._scrollListener()}">
          ${this._renderHeader()}
          <div class="dialog-content">
            ${this._renderDescription()}
            <slot></slot>
          </div>
          ${this._renderButtons()}
        </div>
      </div>
    `;
  }
  _submit(confirmed) {
    send("submit", { confirmed }, this);
  }
}
customElements.define("isceco-dialog", ModalDialog);
export { ModalDialog as default };
